// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__27QiN","dark":"Footer_dark__zuqC5","inner":"Footer_inner__feG0U"};